import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../../images/otpModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { setAuthToken } from "../../../../utils/setAuthToken";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SHA256 } from "crypto-js";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  width: "100%",
  minWidth: "303px!important",
  "@media(max-width:600px)":{width:"303px!important"},
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function ForgotPassModal(props) {
  //Normal use states
  const [newPass, setNewPass] = useState("");
  const [confirmNewPass, setConfirmNewPass] = useState("");

  //Password Hide/Show
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const calculateHash = (inputValue) => {
    const hashedValue = SHA256(inputValue).toString();
    return hashedValue;
  };
  const navigate=useNavigate();
  const updatePassword = (e) => {
    setAuthToken(localStorage.getItem("tempToken"));
    axios
      .post("https://api.blockpay.co.za/forgotpassword/update", {
        email:props.email,
        password: calculateHash(newPass),
        confirmPassword: calculateHash(confirmNewPass),
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res);
        window.location.reload();
    })
    .catch((err) => {
        toast.error(err.response.data.message);
        if (err.response.data.message=="Unauthorized!"){
            localStorage.clear();
            navigate("/signinpin", {replace:true});
          }
        console.log(err);
       
      });
  };
  return (
    <div>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "200px", width: "230px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Forgot Password ?
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                mb: 2,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Change your Password in one click here!
            </Typography>
        
            <TextField
              className="logintextField"
              label="New Password"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      onClick={handleClickShowPassword}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {showPassword ? (
                        <Button
                          sx={{
                            textTransform: "none",
                            color: "gray",
                            paddingRight: "0",
                          }}
                        >
                          <VisibilityOffIcon
                            fontSize="small"
                            sx={{ marginRight: "5px" }}
                          />
                          <Typography
                            sx={{
                              fontWeight: "500",
                            }}
                          >
                            Hide
                          </Typography>
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            textTransform: "none",
                            color: "gray",
                            paddingRight: "0",
                          }}
                        >
                          <VisibilityIcon
                            fontSize="small"
                            sx={{ marginRight: "5px" }}
                          />
                          <Typography
                            sx={{
                              fontWeight: "500",
                            }}
                          >
                            Show
                          </Typography>
                        </Button>
                      )}
                    </Box>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              type={showPassword ? "text" : "password"}
              onChange={(e) => setNewPass(e.target.value)}
              required
            />
            <TextField
              className="logintextField"
              label="Confirm New Password"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      onClick={handleClickShowPassword2}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {showPassword2 ? (
                        <Button
                          sx={{
                            textTransform: "none",
                            color: "gray",
                            paddingRight: "0",
                          }}
                        >
                          <VisibilityOffIcon
                            fontSize="small"
                            sx={{ marginRight: "5px" }}
                          />
                          <Typography
                            sx={{
                              fontWeight: "500",
                            }}
                          >
                            Hide
                          </Typography>
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            textTransform: "none",
                            color: "gray",
                            paddingRight: "0",
                          }}
                        >
                          <VisibilityIcon
                            fontSize="small"
                            sx={{ marginRight: "5px" }}
                          />
                          <Typography
                            sx={{
                              fontWeight: "500",
                            }}
                          >
                            Show
                          </Typography>
                        </Button>
                      )}
                    </Box>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              type={showPassword2 ? "text" : "password"}
              onChange={(e) => setConfirmNewPass(e.target.value)}
              required
            />

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={updatePassword}
              disabled={!newPass || !confirmNewPass}
              sx={{ textTransform: "none", borderRadius: "10px", mb: "1rem" }}
            >
              <span className="buttonSignText">Change Password</span>
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
